import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import SecondarySaga from "./reducer";
const SecondaryHop = combineReducers({
  secondaryIndents: SecondarySaga,
  form: formReducer,
});

export default SecondaryHop;
